import BaseRes from "types/res/BaseRes";
import { Expose } from "class-transformer";

export default class UserRes extends BaseRes {
  @Expose() readonly email: string;
  @Expose() readonly name: string;
  @Expose() readonly screenName: string;
}
